import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";


import "../lodabranding.css";

function Briefintro() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const handleContextMenu = (e) => {
  //   e.preventDefault(); // Disable right-click
  // };

  return (
    <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#181818",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "5rem" : "auto",
        paddingTop: isSmallScreen ? "5rem" : "auto",
      }}
    >
      <Row style={{ height: "auto", width: "100%", }}>
        <p style={{fontSize:'1.8rem',width: isSmallScreen ? '100%' : '80%', lineHeight:'40px'}}>
            A text-based design logo featuring the name "lodapoint". The intention behind 
            this approach is to create a <i style={{color:"#F36F2E"}}>universal</i> and easily <i style={{color:"#F36F2E"}}>recognizable identity </i>
            centered around the app's core name. By keeping it simple and direct, we 
            aim to build strong brand recognition and ensure the name stands out on its own.</p>
      </Row>
    </Container>
  );
}

export default Briefintro;
